<ng-container *ngIf="active == true">
<div *ngIf="hidden != 'true'">
  <div class="system-wide-message alert alert-warning alert-dismissible fade show" role="alert" *ngFor="let status of statuses">
    <div [innerHTML]="status.alert"></div>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<div *ngIf="hidden == 'true'">
  <div class="system-wide-message alert alert-warning alert-dismissible fade show" role="alert" *ngFor="let status of statuses" style="z-index: 799;">
      <div [innerHTML]="status.alert.substr(0 , 100) + '...'"></div>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onOpen()">
      <span aria-hidden="true">+</span>
    </button>
  </div>
</div>
</ng-container>